"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MUTATION_SEARCH_LOCATIONS = void 0;
var client_1 = require("@apollo/client");
exports.MUTATION_SEARCH_LOCATIONS = client_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ($country: String!, $search: String!) {\n    searchLocation(country: $country, search: $search) {\n      locations {\n        name\n        longitude\n        latitude\n      }\n    }\n  }\n"], ["\n  mutation ($country: String!, $search: String!) {\n    searchLocation(country: $country, search: $search) {\n      locations {\n        name\n        longitude\n        latitude\n      }\n    }\n  }\n"])));
var templateObject_1;
